import * as cls from '../../common/base/css-constant';
import * as events from '../../common/base/constant';
import { PivotButton } from '../../common/actions/pivot-button';
import { DataManager } from '@syncfusion/ej2-data';
/**
 * Module to render Axis Fields
 */
/** @hidden */
export class AxisFieldRenderer {
    /** Constructor for render module */
    constructor(parent) {
        this.parent = parent;
    }
    /**
     * Initialize the pivot button rendering
     *
     * @returns {void}
     * @private
     */
    render() {
        if (!this.parent.pivotButtonModule || (this.parent.pivotButtonModule && this.parent.pivotButtonModule.isDestroyed)) {
            new PivotButton(this.parent);
        }
        this.parent.pivotButtonModule.cleanupButtonElements();
        this.createPivotButtons();
    }
    createPivotButtons() {
        const rows = this.parent.dataSourceSettings.rows;
        const columns = this.parent.dataSourceSettings.columns;
        const values = this.parent.dataSourceSettings.values;
        const filters = this.parent.dataSourceSettings.filters;
        const fields = [rows, columns, values, filters];
        const parentElement = this.parent.dialogRenderer.parentElement;
        if (parentElement.querySelector('.' + cls.FIELD_LIST_CLASS + '-filters')) {
            parentElement.querySelector('.' + cls.FIELD_LIST_CLASS + '-filters').querySelector('.' + cls.AXIS_CONTENT_CLASS).innerHTML = '';
        }
        if (parentElement.querySelector('.' + cls.FIELD_LIST_CLASS + '-rows')) {
            parentElement.querySelector('.' + cls.FIELD_LIST_CLASS + '-rows').querySelector('.' + cls.AXIS_CONTENT_CLASS).innerHTML = '';
        }
        if (parentElement.querySelector('.' + cls.FIELD_LIST_CLASS + '-columns')) {
            parentElement.querySelector('.' + cls.FIELD_LIST_CLASS + '-columns').querySelector('.' + cls.AXIS_CONTENT_CLASS).innerHTML = '';
        }
        if (parentElement.querySelector('.' + cls.FIELD_LIST_CLASS + '-values')) {
            parentElement.querySelector('.' + cls.FIELD_LIST_CLASS + '-values').querySelector('.' + cls.AXIS_CONTENT_CLASS).innerHTML = '';
        }
        if ((this.parent.dataType === 'pivot' && this.parent.dataSourceSettings.dataSource &&
            ((!(this.parent.dataSourceSettings.dataSource instanceof DataManager) &&
                (this.parent.dataSourceSettings.dataSource.length > 0)) ||
                (this.parent.dataSourceSettings.dataSource instanceof DataManager && this.parent.engineModule.data &&
                    this.parent.engineModule.data.length > 0))) ||
            (this.parent.dataType === 'olap' && this.parent.dataSourceSettings.url && this.parent.dataSourceSettings.url !== '') ||
            (this.parent.dataSourceSettings.mode === 'Server' && this.parent.dataSourceSettings.url !== '')) {
            const axis = ['rows', 'columns', 'values', 'filters'];
            for (let len = 0, lnt = fields.length; len < lnt; len++) {
                if (fields[len]) {
                    const args = {
                        field: fields[len],
                        axis: axis[len].toString()
                    };
                    this.parent.notify(events.pivotButtonUpdate, args);
                }
            }
        }
    }
    /**
     * Destroys the AxisFieldRenderer instance
     *
     * @returns {void}
     * @hidden
     */
    destroy() {
        const parentElement = this.parent.dialogRenderer.parentElement;
        if (parentElement) {
            const contentSelectors = [
                '.' + cls.FIELD_LIST_CLASS + '-filters',
                '.' + cls.FIELD_LIST_CLASS + '-rows',
                '.' + cls.FIELD_LIST_CLASS + '-columns',
                '.' + cls.FIELD_LIST_CLASS + '-values'
            ];
            for (const selector of contentSelectors) {
                const element = parentElement.querySelector(selector);
                if (element && element.querySelector('.' + cls.AXIS_CONTENT_CLASS)) {
                    element.querySelector('.' + cls.AXIS_CONTENT_CLASS).innerHTML = '';
                }
            }
        }
    }
}
